import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Maps backend error codes to translation keys under "errors.*".
export const errorKey = (err) => {
  if (!err?.response) return "errors.network";
  const detail = err.response.data?.detail;
  if (typeof detail === "string") return `errors.${detail}`;
  if (err.response.status === 422) return "errors.validation";
  return "errors.generic";
};

export const formatMoney = (n, lang) =>
  new Intl.NumberFormat(lang === "es" ? "es-US" : "en-US", { style: "currency", currency: "USD" }).format(n || 0);

export const formatPhone = (p) => (p && p.length === 10 ? `(${p.slice(0, 3)}) ${p.slice(3, 6)}-${p.slice(6)}` : p || "");
